import { GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_ERROR } from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_REQUEST:
      console.log("state", state);
      return {
        requesting: true,
        successful: false,
        user: undefined,
        previousUser: state.user,
        subcription: {},
        error: undefined,
      };

    case GET_USER_SUCCESS:
      return {
        requesting: false,
        successful: true,
        subcription: action.subcription,
        previousUser: state.user,
        user: action.user,
        error: undefined,
      };

    case GET_USER_ERROR:
      return {
        requesting: false,
        successful: false,
        user: undefined,
        subcription: undefined,
        error: action.error,
      };

    default:
      return state;
  }
};
export default reducer;



// WEBPACK FOOTER //
// ./src/pages/admin/reducer.js